export const getBankColor = (bankName?: string | null) => {
  const name = bankName?.toLowerCase() || '';
  if (name.includes('kasikorn') || name.includes('kbank')) return '#138f2d'; // Green
  if (name.includes('scb') || name.includes('siam commercial')) return '#4e2e7f'; // Purple
  if (name.includes('bangkok bank') || name.includes('bbl')) return '#1e4598'; // Blue
  if (name.includes('krungthai') || name.includes('ktb')) return '#1ba5e1'; // Light Blue
  if (name.includes('krungsri') || name.includes('bay') || name.includes('ayudhya')) return '#fec43b'; // Yellow
  if (name.includes('ttb') || name.includes('tmb') || name.includes('thanachart')) return '#0056ff'; // Blue/Red
  if (name.includes('gsb') || name.includes('government savings')) return '#eb198d'; // Pink
  if (name.includes('uob') || name.includes('united overseas')) return '#0b3979'; // Dark Blue
  if (name.includes('cimb')) return '#7e2f36'; // Red
  if (name.includes('kiatnakin') || name.includes('kkp')) return '#695a8f'; // Purple-ish
  if (name.includes('land and houses') || name.includes('lh')) return '#6d6e71'; // Grey
  if (name.includes('baac') || name.includes('agriculture') || name.includes('agiculture') || name.includes('cooperatives')) return '#4b8b3b'; // Green
  if (name.includes('tisco')) return '#1a56a2'; // Blue
  if (name.includes('icbc') || name.includes('industrial and commercial')) return '#c1121c'; // Red
  if (name.includes('ghb') || name.includes('government housing')) return '#f58220'; // Orange
  if (name.includes('exim') || name.includes('export-import')) return '#107e3e'; // Green
  if (name.includes('isb') || name.includes('islamic')) return '#1d4d34'; // Dark Green
  return '#64748b'; // Default Slate-500
};

export const getBankFallbackLogo = (bank?: {
  bankCode?: string | null;
  bankPrefix?: string | null;
  bankNameTH?: string | null;
  bankNameEN?: string | null;
} | null): string | undefined => {
  if (!bank) return undefined;
  const code = (bank.bankCode || '').toLowerCase().trim();
  const prefix = (bank.bankPrefix || '').toLowerCase().trim();
  const nameTH = (bank.bankNameTH || '').toLowerCase().trim();
  const nameEN = (bank.bankNameEN || '').toLowerCase().trim();

  const matches = (targets: string[]): boolean =>
    targets.some(t =>
      code === t || code.includes(t) ||
      prefix === t || prefix.includes(t) ||
      nameTH.includes(t) ||
      nameEN.includes(t)
    );

  if (matches(['kbank', 'kasikorn', 'กสิกร'])) return '/images/bankLogo/กสิกร.png';
  if (matches(['scb', 'siam commercial', 'ไทยพาณิชย์'])) return '/images/bankLogo/ไทยพาณิชย์.png';
  if (matches(['ktb', 'krung thai', 'krungthai', 'กรุงไทย'])) return '/images/bankLogo/กรุงไทย.png';
  if (matches(['bay', 'krungsri', 'กรุงศรี'])) return '/images/bankLogo/กรุงศรี.png';
  if (matches(['bbl', 'bangkok', 'กรุงเทพ', 'bu'])) return '/images/bankLogo/BU.png';
  if (matches(['ttb', 'tmb', 'thanachart', 'tmbthanachart'])) return '/images/bankLogo/ttb.png';
  if (matches(['gsb', 'aomsin', 'government savings', 'ออมสิน'])) return '/images/bankLogo/aomsin.png';
  if (matches(['baac', 'ธกส', 'ธ.ก.ส.'])) return '/images/bankLogo/ธกส.png';
  if (matches(['uob', 'ยูโอบี'])) return '/images/bankLogo/uob.png';
  if (matches(['cimb', 'ซีไอเอ็มบี'])) return '/images/bankLogo/cimb.png';
  if (matches(['lhbank', 'lh bank', 'land and houses', 'แอล เอช'])) return '/images/bankLogo/LH.png';
  if (matches(['ghb', 'ghbank', 'ธอส', 'อาคารสงเคราะห์'])) return '/images/bankLogo/ธอส.png';
  if (matches(['exim', 'ธนาคารส่งออก', 'ส่งออก'])) return '/images/bankLogo/ธนาคารส่งออก.png';
  if (matches(['kkp', 'kiatnakin', 'เกียรตินาคิน'])) return '/images/bankLogo/kkp.png';
  if (matches(['tisco', 'ทิสโก้'])) return '/images/bankLogo/tisco.png';

  return undefined;
};
